import { createContext } from 'react';

export const ReadOnlyContext = createContext(false);
